module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_4.b93802cc.png";